module.exports = __webpack_public_path__ + "static/media/ic-doctor.0aa4e5cc.png";